import {
  Modal,
  Button,
  Box,
  Typography,
  IconButton,
  CircularProgress,
  Divider,
  TextField,
  FormLabel,
  FormControlLabel,
  InputLabel,
  List,
  ListItem,
  Alert,
  Snackbar,
  MenuItem,
  FormControl,
  Select
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

export const StyledModal = styled(Modal)({
  margin: 'auto',
  height: '97%',
  width: '1140px'
});

export const ModalContent = styled(Box)({
  height: '100%',
  width: '100%',
  backgroundColor: 'white',
  outline: 'none',
  borderRadius: '4px',
  boxShadow:
    '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
  padding: '5px 70px',
  boxSizing: 'border-box'
});

export const CloseModalButton = styled(IconButton)({
  marginLeft: '100%',
  marginTop: '20px',
  marginBottom: '-16px',
  '&:hover': {
    background: 'white'
  }
});

export const CloseModalIcon = CloseIcon;

export const Title = styled(Typography)({
  textAlign: 'center',
  fontSize: '34px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  lineHeight: '34px'
});

export const Subtitle = styled(Typography)({
  textAlign: 'center',
  fontSize: '16px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  lineHeight: '30px'
});

export const ModalBody = styled(Box)({
  marginTop: '10px',
  display: 'flex',
  width: '1022px',
  flexDirection: 'column',
  height: 'calc(100vh - 250px)',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    width: '5px'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.1)'
  }
});

export const BodySection = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: '20px',
  width: 'calc(100% - 26px)'
});

export const SectionColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
});

export const SectionDivider = styled(Divider)({
  marginTop: '20px',
  marginBottom: '15px',
  width: 'calc(100% - 26px)'
});

export const SectionDividerMarginTop = styled(Divider)({
  marginTop: '25px',
  width: 'calc(100% - 26px)'
});

export const InputStyle = {
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: 'Open Sans',
  lineHeight: '20px'
};

export const LabelStyle = {
  fontSize: '14px',
  fontFamily: 'Open Sans'
};

export const TextDataValue = styled(TextField)(
  ({ isDisabled, error }: { isDisabled: boolean; error?: boolean }) => ({
    height: '56px',
    marginBottom: '16px',
    '& fieldset': {
      borderRadius: '4px'
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderWidth: '1px',
        borderColor: '#5F65F6'
      },
      '&:hover fieldset': {
        borderColor: isDisabled ? '' : '#5F65F6'
      }
    },
    '& label.Mui-focused': {
      color: error ? 'error' : '#5F65F6'
    }
  })
);

export const ImageDataValue = styled(TextDataValue)({
  marginBottom: '105px',
  width: '170px'
});

export const RadioFormLabel = styled(FormLabel)({
  width: '180px',
  marginLeft: '14px',
  color: '#757575',
  fontSize: '12px',
  fontFamily: 'Open Sans'
});

export const RadiobButtonsGroup = styled(RadioGroup)({
  marginBottom: '15px'
});

export const RadioButtonLabel = styled(FormControlLabel)({});

export const RadioButton = styled(Radio)(({ disabled }: { disabled: boolean | undefined }) => ({
  '&.Mui-checked': {
    color: disabled ? '' : '#5F65F6'
  }
}));

export const SelectCategoryFormControl = styled(FormControl)({
  '& label.Mui-focused': {
    color: '#5F65F6'
  }
});

export const SelectSubcategoryFormControl = styled(FormControl)({
  height: '38px',
  marginTop: '34.5px',
  marginBottom: '35px',
  '& label.Mui-focused': {
    color: '#5F65F6'
  }
});

export const SelectUnitFormControl = styled(FormControl)({
  height: '38px',
  marginBottom: '35px',
  '& label.Mui-focused': {
    color: '#5F65F6'
  }
});

export const SelectInputLabel = styled(InputLabel)(({ isDisabled }: { isDisabled: boolean }) => ({
  ...LabelStyle,
  color: isDisabled ? '#9E9E9E' : '#666666'
}));

export const StyledSelectField = styled(Select)(({ isDisabled }: { isDisabled: boolean }) => ({
  ...InputStyle,
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: '#5F65F6'
    }
  },
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: isDisabled ? '' : '#5F65F6'
    }
  }
}));

const MENU_ITEM_HEIGHT = 36;
export const SelectMenuProps = {
  PaperProps: {
    style: {
      maxHeight: MENU_ITEM_HEIGHT * 5.5
    }
  }
};

export const StyledSelectMenuItem = styled(MenuItem)({
  ...InputStyle
});

export const DataValue = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  lineHeight: '17px',
  marginBottom: '10px',
  letterSpacing: 0.15,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  marginLeft: '15px',
  height: '38px',
  overflow: 'hidden'
});

export const FooterDataValue = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  lineHeight: '17px',
  marginBottom: '10px',
  letterSpacing: 0.15,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  marginLeft: '15px',
  height: '38px',
  overflow: 'hidden',
  marginTop: '35px'
});

export const StyledList = styled(List)({
  display: 'grid',
  gridTemplateColumns: '194px 194px',
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: 'Open Sans'
});

export const StyledListItem = styled(ListItem)({
  marginBottom: '2px'
});

export const ModalFooter = styled(Box)({
  position: 'absolute',
  bottom: '20px',
  display: 'flex',
  width: '1000px',
  height: '85px'
});

export const Spinner = styled(CircularProgress)({
  marginTop: '50vh',
  marginLeft: '50%',
  color: '#5F65F6'
});

export const CloseButton = styled(Button)({
  color: '#3F51B5',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  borderRadius: '10px',
  width: '87px',
  height: '42px',
  border: '1px solid rgba(63, 81, 181, 0.5)',
  textTransform: 'none',
  '&:hover': {
    color: '#3F51B5',
    backgroundColor: '#FFF'
  },
  marginLeft: '572px',
  marginRight: '15px',
  marginTop: '20px'
});

export const UpdateButton = styled(Button)({
  color: 'white',
  background: '#5F65F6',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  borderRadius: '10px',
  width: '178px',
  height: '42px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#5F7EF5'
  },
  '&.Mui-disabled': {
    backgroundColor: '#ACADCF',
    color: '#FFF'
  },
  marginTop: '20px'
});

export { Alert, Snackbar };

export const ErrorSnackbar = styled(Snackbar)({
  height: '68px',
  borderRadius: '4px',
  boxSizing: 'border-box',
  '& .MuiSnackbar-root .MuiSnackbar-anchorOriginTopCenter': {
    fontSize: '40px',
    margin: '30px'
  }
});

export const ListDataValue = styled(Typography)({
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 400,
  paddingTop: 0,
  width: '180px',
  height: '20px',
  lineHeight: '17px',
  marginBottom: '10px',
  letterSpacing: 0.15,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical'
});
